"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueCourseAreas = void 0;
/**
 * Get unique courses formatted as Area objects
 *
 * @param courses - Array of course objects
 * @param areaType - Optional type label for the areas (defaults to 'Course')
 * @returns Array of unique course areas
 */
const getUniqueCourseAreas = (courses, areaType) => {
    // Remove duplicates based on id
    const uniqueCourses = courses.filter((course, index, array) => array.findIndex((item) => item.id === course.id) === index);
    // Convert to Area objects
    return uniqueCourses.map((course) => ({
        id: course.id,
        name: course.name,
        type: areaType,
    }));
};
exports.getUniqueCourseAreas = getUniqueCourseAreas;
